import script from "./OnlineMentalHealthScreeningComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OnlineMentalHealthScreeningComponent.vue?vue&type=script&setup=true&lang=js"

import "./OnlineMentalHealthScreeningComponent.vue?vue&type=style&index=0&id=74ce5cd2&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74ce5cd2"]])

export default __exports__